import {useMemo} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import useQuery from '../../../hooks/useQuery';

export interface RouteInfo {
    routeType: string;
    id: string | undefined;
    pageType: string;
}

function useRouteInfo(): RouteInfo {
    const {eid, pid, page, subPage} = useParams();
    const location = useLocation();
    const query = useQuery();
    const packagePage = query.get('packagePage');

    const routeType = useMemo(() => {
        if (eid) return 'event';
        if (pid) return 'package';
        return '';
    }, [eid, pid]);

    const id = routeType === 'package' ? pid : eid;
    const pathName = location.pathname?.replaceAll('/', '').toLowerCase();

    const pageType = useMemo(() => {
        if (packagePage) return `${routeType}_${packagePage}`;
        if (page) return `${routeType}_${page}${subPage ? `_${subPage}` : ''}`;
        return pathName || 'unknown_page';
    }, [packagePage, routeType, page, subPage, pathName]);

    return {routeType, id, pageType};
}

export default useRouteInfo;
